// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"14ab9a05","977":"b1b09af8"}[chunkId] + ".chunk.js";
};